// src/App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useNavigate } from 'react-router-dom';
import './App.css';



// --- DATA ---
const PRODUCTS_DATA = [
  { id: 1, name: "Premium Cotton Lungi", category: "Lungi", tags: "premium gifting soft", price: 170, mrp: 220, badge: "Premium", brand: "VFC ORIGINALS", desc: "Soft, rich colours · Ideal for premium customers and gifting.", discount: "23% OFF" },
  { id: 2, name: "Budget Friendly Lungi", category: "Lungi", tags: "budget regular", price: 110, mrp: 150, badge: "Budget", brand: "VFC BASIC", desc: "Comfortable, budget-friendly lungi for regular everyday use.", discount: "27% OFF" },
  { id: 3, name: "Dobby Quality Lungi", category: "Lungi", tags: "dobby designer pattern", price: 170, mrp: 230, badge: "Designer", brand: "VFC DESIGNER", desc: "Attractive dobby weave designs ideal for showrooms.", discount: "26% OFF" },
  { id: 4, name: "Super Quality Lungi", category: "Lungi", tags: "super wholesale", price: 130, mrp: 185, badge: "Popular", brand: "VFC CLASSIC", desc: "Comfort, colour fastness, affordability – perfect for bulk orders.", discount: "30% OFF" },
  { id: 5, name: "Cotton Towels", category: "Home Textile", tags: "towel bath face lodge hotel", price: 120, mrp: 160, badge: "Home Textile", brand: "VFC HOME", desc: "Absorbent cotton towels for home, lodge and hotel use.", discount: "25% OFF" },
  { id: 6, name: "Bedspreads", category: "Home Textile", tags: "bedspread bed sheet", price: 100, mrp: 140, badge: "Home Textile", brand: "VFC HOME", desc: "Soft, durable, neatly stitched for long-term use.", discount: "29% OFF" },
  { id: 7, name: "Kerchiefs (1 dozen)", category: "Home Textile", tags: "kerchief hanky handkerchief", price: 130, mrp: 170, badge: "Essentials", brand: "VFC ESSENTIALS", desc: "Plain & printed, custom packing and bulk orders accepted.", discount: "24% OFF" },
];



// --- COMPONENTS ---

const LogoSVG = () => (
  <svg width="85" viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <radialGradient id="bgGrad" cx="50%" cy="35%" r="85%">
        <stop offset="0%" stopColor="#222" />
        <stop offset="70%" stopColor="#050608" />
        <stop offset="100%" stopColor="#000" />
      </radialGradient>
      <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fff4c2" />
        <stop offset="50%" stopColor="#d4af37" />
        <stop offset="100%" stopColor="#9a7b2f" />
      </linearGradient>
      <path id="topTextPath" d="M40,150 A110,110 0 0,1 260,150" />
      <path id="bottomTextPath" d="M260,150 A110,110 0 0,1 40,150" />
      <filter id="softGlow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="3.4" result="blur" />
        <feMerge>
          <feMergeNode in="blur" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    </defs>
    <circle cx="150" cy="150" r="140" fill="url(#bgGrad)" stroke="url(#goldGrad)" strokeWidth="6" />
    <circle cx="150" cy="150" r="125" fill="none" stroke="url(#goldGrad)" strokeWidth="3" />
    <circle cx="150" cy="150" r="100" fill="none" stroke="#666" strokeWidth="1.6" strokeDasharray="3 6" />
    <text x="50%" y="110" textAnchor="middle" fontSize="34" dominantBaseline="middle">🦚</text>
    <text fill="#eedfa5" fontSize="13" letterSpacing="3" fontFamily="Segoe UI">
      <textPath href="#topTextPath" startOffset="50%" textAnchor="middle" dominantBaseline="middle" dy="-2">VADIVELU FABRIC COMPANY</textPath>
    </text>
    <text x="50%" y="150" textAnchor="middle" fontSize="48" fontFamily="Segoe UI" fontWeight="900" fill="url(#goldGrad)" filter="url(#softGlow)">VFC</text>
    <text x="50%" y="190" textAnchor="middle" fontSize="16" letterSpacing="3" fontFamily="Segoe UI" fill="#F5E6B2">SINCE 1988</text>
    <text fill="#eedfa5" fontSize="12" letterSpacing="3" fontFamily="Segoe UI">
      <textPath href="#bottomTextPath" startOffset="50%" textAnchor="middle" dominantBaseline="middle" dy="6">PREMIUM LUNGI MANUFACTURERS</textPath>
    </text>
  </svg>
);



const Header = ({ toggleTheme, theme, cartCount, setFilterCategory }) => {
  const [showProfile, setShowProfile] = useState(false);
  const navigate = useNavigate();

  const handleSubnavClick = (cat) => {
    setFilterCategory(cat === 'Premium' || cat === 'Budget' ? 'All' : cat);
    navigate('/products');
  };

  const closeProfile = () => setShowProfile(false);

  const profileBtnStyle = theme === 'light'
    ? {
        background: '#f8fafc',
        color: '#475569',
        border: '1px solid #cbd5e1',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }
    : {
        background: '#111827',
        color: '#facc15',
        border: '1px solid gold'
      };

  const dropdownStyle = theme === 'light'
    ? {
        position: 'absolute', top: '40px', right: 0,
        background: '#ffffff', border: '1px solid #e2e8f0',
        borderRadius: '12px', padding: '10px',
        display: 'flex', flexDirection: 'column', gap: '8px',
        zIndex: 100, minWidth: '150px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)'
      }
    : {
        position: 'absolute', top: '40px', right: 0,
        background: '#0b1120', border: '1px solid gold',
        borderRadius: '12px', padding: '10px',
        display: 'flex', flexDirection: 'column', gap: '8px',
        zIndex: 100, minWidth: '150px'
      };

  const linkStyle = {
    color: theme === 'light' ? '#374151' : '#e5e7eb',
    padding: '6px 10px',
    borderRadius: '6px',
    display: 'block',
    transition: 'all 0.2s'
  };

  const handleMouseEnter = (e) => {
    e.target.style.background = theme === 'light' ? '#f1f5f9' : 'rgba(250,204,21,0.2)';
  };

  const handleMouseLeave = (e) => {
    e.target.style.background = 'transparent';
  };

  return (
    <div className="header">
      <div className="header-inner">
        <Link to="/" className="brand">
          <LogoSVG />
          <div>
            <div className="brand-text-main">Vadivelu Fabric Company</div>
            <div className="brand-text-sub">Premium Lungi & Home Textile Manufacturers</div>
          </div>
        </Link>
        <div className="header-right">
          <button type="button" className="theme-toggle-btn" onClick={toggleTheme}>
            {theme === 'light' ? '🌙' : '☀️'}
          </button>
          <div style={{ position: 'relative' }}>
            <button
              type="button"
              className="small-cta"
              style={profileBtnStyle}
              onClick={() => setShowProfile(!showProfile)}
            >
              👤 Menu
            </button>
            {showProfile && (
              <div className="profile-dropdown" style={dropdownStyle}>
                <Link
                  to="/"
                  style={linkStyle}
                  onClick={closeProfile}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Home
                </Link>
                <Link
                  to="/products"
                  style={linkStyle}
                  onClick={closeProfile}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Products
                </Link>
                <Link
                  to="/cart"
                  style={linkStyle}
                  onClick={closeProfile}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Cart / Payment
                </Link>
                <Link
                  to="/about"
                  style={linkStyle}
                  onClick={closeProfile}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  About Company
                </Link>
                <Link
                  to="/contact"
                  style={linkStyle}
                  onClick={closeProfile}
                  onMouseEnter={handleMouseEnter}
                  onMouseLeave={handleMouseLeave}
                >
                  Contact
                </Link>
              </div>
            )}
          </div>
          <Link to="/cart" className="cart-pill">
            🛒 Cart: <span>{cartCount}</span>
          </Link>
        </div>
      </div>
      <div className="subnav">
        {['All', 'Lungi', 'Home Textile', 'Premium', 'Budget'].map(cat => (
          <span key={cat} onClick={() => handleSubnavClick(cat)}>{cat}</span>
        ))}
      </div>
    </div>
  );
};



// --- PAGES ---



// HOME now includes previous Profile content
const Home = () => (
  <div className="section">
    {/* Hero */}
    <h1 className="hero-title">
      Fashion-Style <span className="hero-highlight">Lungi & Textile Store</span> from Namakkal
    </h1>
    <p className="hero-meta">
      Experience an online-store layout like Amazon / Meesho / Myntra / Ajio,
      with simple cart and WhatsApp ordering – directly from the manufacturer.
    </p>
    <div style={{ marginTop: '14px', marginBottom: '30px' }}>
      {['Premium Lungis', 'Budget Lungis', 'Dobby & Designer', 'Super Quality', 'Towels', 'Bedspreads', 'Kerchiefs'].map(t => (
        <span key={t} className="chip">{t}</span>
      ))}
    </div>

    {/* Customer profile-style section */}
    <h2 style={{ textAlign: 'center', background: 'linear-gradient(135deg, #facc15, #eab308)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontSize: '2.2em', marginBottom: '8px' }}>
      👑 VFC Customer Profile
    </h2>

    <div style={{
      background: 'linear-gradient(135deg, rgba(250,204,21,0.15) 0%, rgba(234,179,8,0.1) 100%)',
      padding: '32px',
      borderRadius: '24px',
      border: '2px solid rgba(250,204,21,0.4)',
      boxShadow: '0 20px 40px rgba(250,204,21,0.15), 0 0 0 1px rgba(250,204,21,0.1)',
      marginTop: '24px',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute',
        top: '-50px', right: '-50px',
        width: '100px', height: '100px',
        background: 'radial-gradient(circle, rgba(250,204,21,0.3) 0%, transparent 70%)',
        borderRadius: '50%'
      }} />

      <div style={{ position: 'relative', zIndex: 1 }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '24px',
          fontSize: '64px'
        }}>
          👤
        </div>

        <h3 style={{
          color: '#facc15',
          margin: '0 0 24px 0',
          textAlign: 'center',
          fontSize: '1.8em',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
          textShadow: '0 2px 4px rgba(250,204,21,0.3)'
        }}>
          Your Premium Shopping Experience
        </h3>

        <div style={{
          background: 'rgba(15,23,42,0.9)',
          padding: '24px',
          borderRadius: '16px',
          borderLeft: '5px solid #facc15',
          marginBottom: '24px',
          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)'
        }}>
          <h4 style={{ color: '#facc15', margin: '0 0 16px 0', fontSize: '1.3em' }}>
            🏆 OUR LEGACY OF EXCELLENCE
          </h4>
          <p style={{ fontSize: '15px', lineHeight: '1.7', margin: 0, color: '#e5e7eb' }}>
            For over <strong>37 glorious years</strong> since 1988, <strong>Vadivelu Fabric Company</strong> has been the
            trusted name in premium lungi manufacturing. Founded by visionary <strong>Mohan Pongiyannan</strong>, our
            second-generation enterprise thrives under the dynamic leadership of <strong>CEO Vadivelu Mohan</strong>.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
          gap: '20px',
          marginBottom: '24px'
        }}>
          <div style={{
            background: 'rgba(250,204,21,0.08)',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid rgba(250,204,21,0.2)'
          }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>🛍️</div>
            <h5 style={{ color: '#facc15', margin: '0 0 12px 0' }}>Seamless Shopping</h5>
            <p style={{ fontSize: '14px', lineHeight: '1.6', margin: 0, color: '#9ca3af' }}>
              Your cart, order history, and preferences are securely saved for lightning-fast reordering and personalized recommendations.
            </p>
          </div>

          <div style={{
            background: 'rgba(250,204,21,0.08)',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid rgba(250,204,21,0.2)'
          }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>🚚</div>
            <h5 style={{ color: '#facc15', margin: '0 0 12px 0' }}>Express Delivery</h5>
            <p style={{ fontSize: '14px', lineHeight: '1.6', margin: 0, color: '#9ca3af' }}>
              Direct-from-factory shipping across India with CEO Vadivelu Mohan's personal oversight on every premium order.
            </p>
          </div>

          <div style={{
            background: 'rgba(250,204,21,0.08)',
            padding: '20px',
            borderRadius: '12px',
            border: '1px solid rgba(250,204,21,0.2)'
          }}>
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>💎</div>
            <h5 style={{ color: '#facc15', margin: '0 0 12px 0' }}>Premium Quality</h5>
            <p style={{ fontSize: '14px', lineHeight: '1.6', margin: 0, color: '#9ca3af' }}>
              Experience Namakkal's finest lungis – from budget-friendly classics to designer dobby weaves for every occasion.
            </p>
          </div>
        </div>

        <div style={{
          background: 'linear-gradient(135deg, rgba(16,185,129,0.2) 0%, rgba(34,197,94,0.1) 100%)',
          padding: '24px',
          borderRadius: '16px',
          border: '2px solid rgba(16,185,129,0.4)',
          textAlign: 'center',
          boxShadow: '0 8px 32px rgba(16,185,129,0.15)'
        }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>🏆</div>
          <h4 style={{ color: '#10b981', margin: '0 0 16px 0', fontSize: '1.4em' }}>
            "Moving Forward with Faith, Finishing with Success"
          </h4>
          <p style={{ fontSize: '15px', color: '#047857', fontStyle: 'italic', margin: 0 }}>
            Join thousands of satisfied customers who trust VFC for unmatched quality, service, and tradition.
          </p>
        </div>

        <div style={{
          marginTop: '32px',
          padding: '20px',
          background: 'rgba(15,23,42,0.8)',
          borderRadius: '16px',
          textAlign: 'center',
          border: '1px solid rgba(250,204,21,0.3)'
        }}>
          <p style={{ fontSize: '14px', color: '#d1d5db', margin: '0 0 16px 0' }}>
            💾 All your orders and preferences are safely stored here for a seamless, personalized shopping journey.
          </p>
          <div style={{ fontSize: '24px', color: '#facc15' }}>
            ✨ Welcome to the VFC Family ✨
          </div>
        </div>
      </div>
    </div>
  </div>
);



const About = () => (
  <div className="section">
    <h2>About Our Company</h2>
    <div style={{ background: 'rgba(15,23,42,0.8)', padding: '20px', borderRadius: '12px', borderLeft: '4px solid #facc15', marginTop: '16px' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: '12px', fontSize: '14px' }}>
        <strong>Company Name:</strong>
        <span>Vadivelu Fabric Company</span>

        <strong>Owner / Proprietor:</strong>
        <span>AM. VADIVELU</span>

        <strong>Established:</strong>
        <span>Since 1988</span>

        <strong>Industry:</strong>
        <span>Wholesale & Retail Lungis, Home Textiles</span>

        <strong>Employees:</strong>
        <span>101 – 500</span>

        <strong>Annual Turnover:</strong>
        <span>5 – 25 Crores</span>

        <strong>GST Number:</strong>
        <span>33AFWPV3836J1ZO</span>

        <strong>Address:</strong>
        <span>6-2-8-D1-1A Ayakkatur Alampalayam, Tamil Nadu, 638007</span>

        <strong>District:</strong>
        <span>Namakkal District</span>
      </div>
    </div>
    <p style={{ marginTop: '20px', fontSize: '14px' }}>
      Manufacturer of Premium Lungis in Namakkal District, Tamil Nadu.
    </p>
  </div>
);



const Products = ({ cart, addToCart, removeFromCart, filterCategory: initialCat }) => {
  const [category, setCategory] = useState(initialCat || 'All');
  const [priceRange, setPriceRange] = useState('All');
  const [sortBy, setSortBy] = useState('default');
  const [search, setSearch] = useState('');

  useEffect(() => {
    if (initialCat) setCategory(initialCat);
  }, [initialCat]);

  const filteredProducts = PRODUCTS_DATA.filter(p => {
    if (category !== 'All' && p.category !== category) return false;
    if (priceRange !== 'All') {
      const [min, max] = priceRange.split('-').map(Number);
      if (!(p.price >= min && p.price <= max)) return false;
    }
    if (search && !(p.name.toLowerCase().includes(search.toLowerCase()) || p.tags.includes(search.toLowerCase()))) return false;
    return true;
  }).sort((a, b) => {
    if (sortBy === 'price-asc') return a.price - b.price;
    if (sortBy === 'price-desc') return b.price - a.price;
    return 0;
  });

  return (
    <div className="section">
      <h2>All Products</h2>
      <div className="products-layout">
        <div className="filters-card">
          <h3 style={{ color: '#facc15', textTransform: 'uppercase' }}>Filters</h3>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px' }}>Category</label>
            <select value={category} onChange={e => setCategory(e.target.value)}>
              <option value="All">All</option>
              <option value="Lungi">Lungis</option>
              <option value="Home Textile">Home Textile</option>
            </select>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px' }}>Price</label>
            <select value={priceRange} onChange={e => setPriceRange(e.target.value)}>
              <option value="All">All</option>
              <option value="0-120">Up to ₹120</option>
              <option value="121-170">₹121 – ₹170</option>
            </select>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ display: 'block', marginBottom: '6px', fontSize: '12px' }}>Sort By</label>
            <select value={sortBy} onChange={e => setSortBy(e.target.value)}>
              <option value="default">Recommended</option>
              <option value="price-asc">Price: Low to High</option>
              <option value="price-desc">Price: High to Low</option>
            </select>
          </div>
          <input
            placeholder="Search products..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
        </div>

        <div className="products-grid">
          {filteredProducts.map(p => (
            <div key={p.id} className="product-card">
              <span className="product-badge">{p.badge}</span>
              {/* <div style={{ height: '140px', background: '#111', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#555', fontSize: '10px', border: '1px solid #333', marginBottom: '8px' }}>
                [Product Image]
              </div> */}
              <div style={{ fontSize: '11px', color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.14em', marginTop: '10px' }}>{p.brand}</div>
              <div className="product-title">{p.name}</div>
              <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', marginBottom: '6px' }}>
                <span className="product-price">₹{p.price}</span>
                <span className="product-mrp">₹{p.mrp}</span>
                <span style={{ fontSize: '11px', color: '#4ade80', fontWeight: '600' }}>{p.discount}</span>
              </div>
              <p style={{ fontSize: '11px', color: '#9ca3af', marginBottom: '6px' }}>{p.desc}</p>
              <div className="cart-controls">
                <button className="qty-btn" onClick={() => removeFromCart(p.name)}>-</button>
                <span style={{ minWidth: '18px', textAlign: 'center', fontSize: '13px' }}>{cart[p.name]?.qty || 0}</span>
                <button className="qty-btn" onClick={() => addToCart(p.name, p.price)}>+</button>
                <button className="add-to-cart-main" onClick={() => addToCart(p.name, p.price)}>Add to Cart</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};



const Cart = ({ cart, addToCart, removeFromCart, totalAmount }) => {
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [showPaymentScreenshot, setShowPaymentScreenshot] = useState(false);
  const [customerDetails, setCustomerDetails] = useState({
    name: '',
    phone: '',
    address: '',
    email: '',
    transactionId: ''
  });
  const [paymentScreenshot, setPaymentScreenshot] = useState(null);
  const [orderSubmitted, setOrderSubmitted] = useState(false);

  const generateUpiLink = (amount) => {
    const params = new URLSearchParams({
      pa: '9976791919@ybl',
      pn: 'Vadivelu Fabric Company',
      cu: 'INR',
      am: amount.toString()
    });
    return `upi://pay?${params.toString()}`;
  };

  const upiLink = generateUpiLink(totalAmount);
  const qrSrc = `https://api.qrserver.com/v1/create-qr-code/?size=260x260&data=${encodeURIComponent(upiLink)}`;

  const generateWhatsAppMessage = () => {
    let messageLines = [
      '🧾 *NEW ORDER REQUEST*',
      '',
      '*ORDER ITEMS:*'
    ];

    Object.keys(cart).forEach((name, i) => {
      const item = cart[name];
      messageLines.push(`${i + 1}. *${name}* × ${item.qty} = ₹${item.qty * item.price}`);
    });

    messageLines.push('', `*TOTAL: ₹${totalAmount}*`, '');

    messageLines.push('*👤 CUSTOMER DETAILS:*');
    messageLines.push(`Name: ${customerDetails.name || 'N/A'}`);
    messageLines.push(`Phone: ${customerDetails.phone || 'N/A'}`);
    messageLines.push(`Email: ${customerDetails.email || 'N/A'}`);
    messageLines.push(`Address: ${customerDetails.address.replace(/\n/g, '\\n') || 'N/A'}`);
    messageLines.push(`Transaction ID: ${customerDetails.transactionId || 'N/A'}`);
    messageLines.push('');

    messageLines.push('*📦 DELIVERY INFO:*');
    messageLines.push('Delivered by: CEO Vadivelu Mohan');
    messageLines.push('Address: 6-2-8-D1-1A Ayakkatur Alampalayam, Namakkal District, Tamil Nadu 638007');
    messageLines.push('');
    messageLines.push('✅ *ORDER CONFIRMED!*');
    messageLines.push('📞 Contact: +91 99767 91919');

    return messageLines.join('\n');
  };

  const handlePaymentConfirm = () => {
    setShowAddressForm(true);
  };

  const handleAddressSubmit = () => {
    if (!customerDetails.name || !customerDetails.phone || !customerDetails.address || !customerDetails.transactionId) {
      alert('Please fill Name, Phone, Address, and Transaction ID (all mandatory).');
      return;
    }
    setShowPaymentScreenshot(true);
  };

  const handleScreenshotUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPaymentScreenshot(URL.createObjectURL(file));
    }
  };

  const handleShare = () => {
    if (!paymentScreenshot) {
      alert('Please upload payment screenshot before submitting.');
      return;
    }

    const whatsappMessage = generateWhatsAppMessage();
    const whatsappUrl = `https://wa.me/919976791919?text=${encodeURIComponent(whatsappMessage)}`;

    window.open(whatsappUrl, "_blank");
    setOrderSubmitted(true);
  };

  const handleFileInputClick = () => {
    document.getElementById('screenshotInput').click();
  };

  return (
    <div className="section">
      <h2>Cart & Payment</h2>

      <div style={{ background: 'rgba(15,23,42,0.98)', border: '1px solid rgba(250,204,21,0.7)', borderRadius: '14px', padding: '14px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700' }}>
          <span>Total Items: {Object.values(cart).reduce((a, b) => a + b.qty, 0)}</span>
          <span>Total: ₹{totalAmount}</span>
        </div>
        <ul style={{ marginTop: '10px', listStyle: 'none', padding: 0 }}>
          {Object.keys(cart).map((name, i) => (
            <li key={name} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #333' }}>
              <span style={{ flex: 1, fontSize: '13px' }}>{i + 1}. {name}</span>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <button className="small-cta" onClick={() => removeFromCart(name)}>-</button>
                <span>{cart[name].qty}</span>
                <button className="small-cta" onClick={() => addToCart(name, cart[name].price)}>+</button>
              </div>
              <span style={{ width: '60px', textAlign: 'right', fontSize: '13px' }}>₹{cart[name].qty * cart[name].price}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* QR Code Section */}
      {!showAddressForm && !orderSubmitted && (
        <div className="section" style={{ marginTop: '18px' }}>
          <h3>UPI / Google Pay</h3>
          <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
            <img src={qrSrc} alt="QR" style={{ width: '160px', borderRadius: '12px' }} />
            <div>
              <p>UPI ID: <b>9976791919@ybl</b></p>
              <a href={upiLink} className="small-cta upi-btn">Open UPI App</a>
            </div>
          </div>
          <button
            className="small-cta whatsapp-btn"
            onClick={handlePaymentConfirm}
            style={{ marginTop: '16px', width: '100%', background: '#facc15', color: '#111827', fontWeight: '700' }}
          >
            📱 Payment Done - Confirm Order Details
          </button>
        </div>
      )}

      {/* Address Form */}
      {showAddressForm && !showPaymentScreenshot && !orderSubmitted && (
        <div className="section" style={{ marginTop: '18px' }}>
          <h3>📦 Customer Confirmation Details <span style={{ color: '#ef4444' }}>*All Fields Mandatory*</span></h3>
          <div style={{ background: 'rgba(250,204,21,0.05)', padding: '20px', borderRadius: '12px', border: '2px solid #facc15', marginTop: '12px' }}>
            <input
              placeholder="Full Name *"
              value={customerDetails.name}
              onChange={(e) => setCustomerDetails({ ...customerDetails, name: e.target.value })}
              style={{ width: '100%', padding: '12px', marginBottom: '12px', border: '1px solid #d4d4d8', borderRadius: '8px' }}
              required
            />
            <input
              placeholder="Phone Number *"
              value={customerDetails.phone}
              onChange={(e) => setCustomerDetails({ ...customerDetails, phone: e.target.value })}
              style={{ width: '100%', padding: '12px', marginBottom: '12px', border: '1px solid #d4d4d8', borderRadius: '8px' }}
              required
            />
            <textarea
              placeholder="Complete Delivery Address *"
              value={customerDetails.address}
              onChange={(e) => setCustomerDetails({ ...customerDetails, address: e.target.value })}
              style={{ width: '100%', padding: '12px', marginBottom: '12px', border: '1px solid #d4d4d8', borderRadius: '8px', minHeight: '80px' }}
              required
            />
            <input
              placeholder="Transaction ID / UPI Reference *"
              value={customerDetails.transactionId}
              onChange={(e) => setCustomerDetails({ ...customerDetails, transactionId: e.target.value })}
              style={{ width: '100%', padding: '12px', marginBottom: '16px', border: '1px solid #d4d4d8', borderRadius: '8px' }}
              required
            />
            <input
              placeholder="Email (optional)"
              value={customerDetails.email}
              onChange={(e) => setCustomerDetails({ ...customerDetails, email: e.target.value })}
              style={{ width: '100%', padding: '12px', marginBottom: '16px', border: '1px solid #d4d4d8', borderRadius: '8px' }}
            />
            <button
              className="small-cta whatsapp-btn"
              onClick={handleAddressSubmit}
              style={{ width: '100%', background: '#10b981', color: 'white', fontWeight: '700' }}
            >
              ✅ Submit Details - Upload Payment Screenshot
            </button>
          </div>
        </div>
      )}

      {/* Payment Screenshot Upload */}
      {showPaymentScreenshot && !orderSubmitted && (
        <div className="section" style={{ marginTop: '18px' }}>
          <h3>💳 Upload Payment Screenshot <span style={{ color: '#ef4444' }}>*Mandatory*</span></h3>
          <div style={{ background: 'rgba(34,197,94,0.1)', padding: '20px', borderRadius: '12px', border: '2px solid #10b981', marginTop: '12px', textAlign: 'center' }}>
            {paymentScreenshot ? (
              <>
                <img src={paymentScreenshot} alt="Payment Proof" style={{ maxWidth: '200px', maxHeight: '200px', borderRadius: '8px', marginBottom: '12px' }} />
                <p style={{ color: '#10b981', fontWeight: '600' }}>✅ Payment screenshot uploaded successfully!</p>
              </>
            ) : (
              <>
                <div style={{ width: '120px', height: '120px', border: '3px dashed #10b981', borderRadius: '12px', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#10b981', fontSize: '48px' }}>
                  📱
                </div>
                <p style={{ color: '#374151', marginBottom: '16px' }}>Upload your UPI/Google Pay transaction screenshot</p>
              </>
            )}
            <input
              id="screenshotInput"
              type="file"
              accept="image/*"
              onChange={handleScreenshotUpload}
              style={{ display: 'none' }}
            />
            <button
              className="small-cta whatsapp-btn"
              onClick={paymentScreenshot ? handleShare : handleFileInputClick}
              style={{ width: '100%', background: paymentScreenshot ? '#facc15' : '#6b7280', color: '#111827', fontWeight: '700' }}
            >
              {paymentScreenshot ? '🚀 Send Complete Order to CEO via WhatsApp' : '📤 Choose Payment Screenshot'}
            </button>
          </div>
        </div>
      )}

      {orderSubmitted && (
        <div className="section" style={{ marginTop: '18px', textAlign: 'center' }}>
          <div style={{ fontSize: '48px', marginBottom: '16px' }}>✅</div>
          <h3 style={{ color: '#10b981' }}>Order Sent Successfully!</h3>
          <p style={{ color: '#6b7280', marginTop: '8px' }}>
            CEO Vadivelu Mohan will process and deliver your order shortly.
          </p>
          <div style={{ marginTop: '20px' }}>
            <Link to="/" className="small-cta" style={{ marginRight: '12px' }}>🏠 Continue Shopping</Link>
            <button className="small-cta" onClick={() => window.location.reload()}>🛒 New Order</button>
          </div>
        </div>
      )}
    </div>
  );
};



// --- MAIN APP ---
function App() {
  const [theme, setTheme] = useState('dark');
  const [cart, setCart] = useState({});
  const [filterCategory, setFilterCategory] = useState('All');

  useEffect(() => {
    const saved = localStorage.getItem('vfc_cart');
    if (saved) setCart(JSON.parse(saved));
  }, []);

  useEffect(() => {
    localStorage.setItem('vfc_cart', JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    document.body.className = theme === 'light' ? 'theme-light' : 'theme-dark';
  }, [theme]);

  const toggleTheme = () => setTheme(prev => prev === 'dark' ? 'light' : 'dark');

  const addToCart = (name, price) => {
    setCart(prev => {
      const existing = prev[name] || { price, qty: 0 };
      return { ...prev, [name]: { price, qty: existing.qty + 1 } };
    });
  };

  const removeFromCart = (name) => {
    setCart(prev => {
      const existing = prev[name];
      if (!existing) return prev;
      if (existing.qty <= 1) {
        const next = { ...prev };
        delete next[name];
        return next;
      }
      return { ...prev, [name]: { ...existing, qty: existing.qty - 1 } };
    });
  };

  const totalAmount = Object.values(cart).reduce((sum, item) => sum + (item.price * item.qty), 0);
  const cartCount = Object.values(cart).reduce((sum, item) => sum + item.qty, 0);

  return (
    <Router>
      <div className="page-wrapper">
        <Header theme={theme} toggleTheme={toggleTheme} cartCount={cartCount} setFilterCategory={setFilterCategory} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={
            <Products
              cart={cart}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              filterCategory={filterCategory}
            />
          } />
          <Route path="/cart" element={
            <Cart
              cart={cart}
              addToCart={addToCart}
              removeFromCart={removeFromCart}
              totalAmount={totalAmount}
            />
          } />
          <Route path="/contact" element={
            <div className="section">
              <h2>Contact Us</h2>
              <p>Phone/WhatsApp: +91 99767 91919</p>
              <p>Email: amvadivelu@gmail.com</p>
              <p><strong>Address:</strong> 6-2-8-D1-1A Ayakkatur Alampalayam, Tamil Nadu, 638007</p>
              <p><strong>District:</strong> Namakkal District</p>
            </div>
          } />
          <Route path="/about" element={<About />} />
        </Routes>

        <footer>
          © Vadivelu Fabric Company • Namakkal District • Phone: +91 99767 91919
        </footer>
      </div>
    </Router>
  );
}

export default App;
